/**
 * Enum for all possible TopBar action IDs to ensure type safety and prevent conflicts
 */
export enum TopBarActionId {
  // Workflow-related actions
  WORKFLOW_TRACE = 'workflow-trace',
  WORKFLOW_DETAILS = 'workflow-details',
  WORKFLOW_TAGS = 'workflow-tags',
  WORKFLOW_BOOKMARK = 'workflow-bookmark',
  WORKFLOW_EXPORT_TEMPLATE = 'workflow-export-template',

  // Results-related actions
  WORKFLOW_RESULTS_SHARE = 'workflow-results-share',
  WORKFLOW_RESULTS_DOWNLOAD = 'workflow-results-download',
  WORKFLOW_RESULTS_CLEAR = 'workflow-results-clear',

  // Panel-related actions
  PANEL_BACK = 'panel-back',
  PANEL_DOWNLOAD = 'panel-download',
  PANEL_SHARE = 'panel-share',
  PANEL_EXPORT_MARKDOWN = 'panel-export-markdown',
  PANEL_COPY = 'panel-copy',
  PANEL_EDIT = 'panel-edit',
  PANEL_FORK = 'panel-fork',
  PANEL_LOAD_TO_CONTEXT = 'panel-load-to-context',

  // Add new action IDs here as needed
}

/**
 * Type guard to check if a string is a valid TopBarActionId
 */
export function isValidActionId(id: string): id is TopBarActionId {
  return Object.values(TopBarActionId).includes(id as TopBarActionId)
}

/**
 * Utility to get all action IDs as an array
 */
export function getAllActionIds(): TopBarActionId[] {
  return Object.values(TopBarActionId)
}

/**
 * Development-mode validation function to check for duplicate action IDs
 */
export function validateActionIds(actionIds: string[]): void {
  if (process.env.NODE_ENV === 'development') {
    const seen = new Set<string>()
    const duplicates = new Set<string>()

    for (const id of actionIds) {
      if (seen.has(id)) {
        duplicates.add(id)
      } else {
        seen.add(id)
      }
    }

    if (duplicates.size > 0) {
      console.warn('[TopBar] Duplicate action IDs detected:', Array.from(duplicates))
    }

    // Check for invalid IDs
    const invalid = actionIds.filter((id) => !isValidActionId(id))
    if (invalid.length > 0) {
      console.warn('[TopBar] Invalid action IDs detected (not in enum):', invalid)
    }
  }
}
